import {Component, Input, OnInit} from '@angular/core';
import {OrdineGroup} from '../../_models/OrdineGroup';
import {StatoEnum} from '../../_models/generated/stato-enum';

@Component({
  selector: 'app-ordine-sessioni',
  templateUrl: './ordine-sessioni.component.html',
  styleUrls: ['./ordine-sessioni.component.scss'],
  standalone: false
})
export class OrdineSessioniComponent implements OnInit {
  @Input() ordine: OrdineGroup;
  tempoAttualeSecondi = 0;
  protected readonly parseFloat = parseFloat;
  protected readonly StatoEnum = StatoEnum

  constructor() { }

  ngOnInit() {
    setInterval(() => {
      const dataOggi = new Date();
      if (this.ordine == null) {
        return;
      }
      this.ordine.tempoParzialeLav = '0';
      this.tempoAttualeSecondi = 0;
      //this.ordine.tempoParzialeLav = this.ordine.partialWorkingHours.toString();
      if (this.ordine.stato === StatoEnum.AVANZAMENTO) {
        this.ordine.tempoParzialeLav = ((((dataOggi.valueOf() / 1000) - this.ordine.lastActionTime) / 60) / 60).toFixed(4);
        this.tempoAttualeSecondi = (dataOggi.valueOf() / 1000) - this.ordine.lastActionTime;
      }
    }, 10);
  }
}
